// src/plugins/vant-components.js
import {
  Row,
  Col,
  Search,
  Field,
  NavBar,
  Lazyload,
  Overlay,
  Loading as VantLoading,
  Icon,
  Calendar,
  Image,
  ImagePreview,
  Dialog,
  Button,
  DatetimePicker,
  Popup,
  Uploader,
  Toast,
  List,
  Collapse,
  CollapseItem,
  Form,
  RadioGroup,
  Radio,
  IndexBar,
  IndexAnchor,
  Cell,
  CellGroup,
  Picker,
  Switch
} from "vant";

// 组件列表
const components = [
  Row,
  Col,
  Search,
  Field,
  NavBar,
  Lazyload,
  Overlay,
  VantLoading,
  Icon,
  Calendar,
  Image,
  ImagePreview,
  Dialog,
  Button,
  DatetimePicker,
  Popup,
  Uploader,
  List,
  Collapse,
  CollapseItem,
  Form,
  RadioGroup,
  Radio,
  IndexBar,
  IndexAnchor,
  Cell,
  CellGroup,
  Picker,
  Switch
];

// 安装方法
export default {
  install(Vue) {
    components.forEach((component) => {
      Vue.use(component);
    });

    // 非组件式API处理
    Vue.prototype.$toast = Toast;
    Vue.prototype.$imagePreview = ImagePreview;
  },
};
